module.exports = __webpack_public_path__ + "static/media/logos_50h_microsoft.efa6b0d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/logo_bar/logos_50h_microsoft.jpg
// module id = 221
// module chunks = 0